/**
 * EffectsSidebarWrapper Component
 * Animated sidebar panel for track effects with metronome and count-in controls
 */

import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { InlineEffectsPanel } from './index';
import InAppUpsells from '../marketplace/InAppUpsells';

export const EffectsSidebarWrapper = ({
  isOpen,
  onClose,
  isMobile,
  track,
  onUpdate,
  onOpenAdvancedEffects,
  isPro,
  userTier = 'free',
  // Metronome
  metronomeEnabled,
  setMetronomeEnabled,
  metronomeVolume,
  setMetronomeVolume,
  timeSignature,
  setTimeSignature,
  showCollaboration,
  currentBeat,
  // Count-in
  countInEnabled,
  setCountInEnabled,
  countInBeats,
  setCountInBeats,
}) => {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.aside
          initial={{ x: 320 }}
          animate={{ x: 0 }}
          exit={{ x: 320 }}
          className={`${isMobile ? 'absolute right-0 top-[57px] bottom-8 z-30' : 'relative'} w-72 md:w-80 bg-zinc-900/70 backdrop-blur-md border-l border-zinc-800/50 flex flex-col`}
        >
          <InlineEffectsPanel
            track={track}
            onUpdate={onUpdate}
            onClose={onClose}
            onOpenAdvancedEffects={onOpenAdvancedEffects}
            isPro={isPro}
            metronome={{
              enabled: metronomeEnabled,
              setEnabled: setMetronomeEnabled,
              volume: metronomeVolume,
              setVolume: setMetronomeVolume,
              timeSignature,
              setTimeSignature: (newTs) => {
                setTimeSignature(newTs);
                // Broadcast time signature change to collaborators
                if (showCollaboration && window.__collabSendTimeSignature) {
                  window.__collabSendTimeSignature(newTs);
                }
              },
              currentBeat
            }}
            countIn={{
              enabled: countInEnabled,
              setEnabled: setCountInEnabled,
              beats: countInBeats,
              setBeats: setCountInBeats
            }}
          />
          
          {/* In-App Upsells Section */}
          <div className="mt-auto p-3 border-t border-zinc-800/50">
            <InAppUpsells 
              position="sidebar" 
              currentContext="mixing"
              userTier={userTier}
            />
          </div>
        </motion.aside>
      )}
    </AnimatePresence>
  );
};

export default EffectsSidebarWrapper;
